var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.stars),function(i){return _c('v-icon',{key:i,attrs:{"x-small":_vm.small,"color":'#fff'}},[_vm._v(" "+_vm._s(_vm.icons.star)+" ")])}),(_vm.isSuperior)?_c('v-icon',{attrs:{"x-small":_vm.small,"color":'#fff'}},[_vm._v(" "+_vm._s(_vm.icons.superior)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }